import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Section';
import { dolores } from '../data/dolores';
export function PainGrid() {
  return <Section tone="white" data-id="element-139" data-mp="1zhi4pyrz7x20">
      <h2 className="mx-auto max-w-[34ch] text-center font-serif text-[26px] leading-tight sm:text-[34px] md:max-w-[42ch]" data-id="element-140" data-mp="1uogqlszlg1jh">
        Si organizas fiestas de 15 — o sueñas con vivir de eso — por lo menos
        uno de estos te va a sonar dolorosamente familiar:
      </h2>

      <ul className="mt-12 grid gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-141" data-mp="1llxq3fja610e">
        {dolores.map(dolor => <li key={dolor} className="flex items-start gap-3.5" data-id="element-142" data-mp="1gra901qlw8vu">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-card bg-blush" aria-hidden="true" data-id="element-143" data-mp="1bqmakv01sprl">
              <XIcon className="h-3.5 w-3.5 text-blush-ink" strokeWidth={2.5} data-id="element-144" data-mp="3645ceh142uip" />
            </span>
            <p className="text-[15px] leading-relaxed text-ink-soft" data-id="element-145" data-mp="3220kpnu847yp">{dolor}</p>
          </li>)}
      </ul>

      <p className="mx-auto mt-14 max-w-[30ch] text-center font-serif text-2xl italic leading-snug text-ink sm:text-3xl" data-id="element-146" data-mp="3g81wnp7k0k4g">
        ¿Y si cada uno de estos ya estuviera resuelto — paso a paso, tomo por
        tomo?
      </p>
    </Section>;
}